export default {
  // 画行政区
  drawCity(currentMap) {
    let that = this;
    let district = new AMap.DistrictSearch({
      // 返回行政区边界坐标等具体信息
      extensions: "all",
      // 设置查询行政区级别为 市
      level: "city",
    });
    district.search("杭州市", function (status, result) {
      console.log("result", result);
      let bounds = result.districtList[0].boundaries;
      let polygons = [];
      if (bounds) {
        for (let i = 0, l = bounds.length; i < l; i++) {
          //生成行政区划polygon
          let polygon = new AMap.Polygon({
            map: currentMap,
            strokeWeight: 1,
            path: bounds[i],
            // fillOpacity: 0.6,
            fillOpacity: 0.7,
            bubble: true,
            // fillColor: '#CCF3FF',
            // fillColor: '#55dad9',
            fillColor: "#ffffff",
            strokeColor: "#CC66CC",
          });
          polygons.push(polygon);
        }
      }
    });
  },

  drawDistrict: async function (currentMap, bg) {
    let that = this;
    let areaList = await that.getAreas("区域");
    let colorMap = {
      上城区: "#ff9b5e",
      拱墅区: "#8f99ff",
      余杭区: "#fca498",
      临平区: "#b2dcff",
      富阳区: "#f2e3e0",
      临安区: "#ffbcec",
      萧山区: "#fff294",
      滨江区: "#eb9bff",
      钱塘区: "#cdd0ef",
      西湖区: "#afe863",
    };
    let colorMap1 = {
      相城区: "#e0858a",
      姑苏区: "#faf5b5",
      高新区: "#acf4f4",
      工业园区: "#e288e5",
      吴江区: "#b7cace",
      太仓市: "#aba7b9",
      常熟市: "#c889a0",
      张家港市: "#7e7db4",
      昆山市: "#eecdaa",
      吴中区: "#9ac696",
    };
    let colorMap2 = {
      崇明区: "#e0858a",
      浦东新区: "#faf5b5",
      金山区: "#acf4f4",
      黄浦区: "#e288e5",
      杨浦区: "#b7cace",
      虹口区: "#aba7b9",
      静安区: "#c889a0",
      嘉定区: "#7e7db4",
      松江区: "#eecdaa",
      长宁区: "#9ac696",
      奉贤区: "#ffbcec",
      青浦区: "#fff294",
      宝山区: "#eb9bff",
      普陀区: "#cdd0ef",
      徐汇区: "#afe863",
      闵行区: "#8f99ff",
    };
    for (let i = 0; i < areaList.length; i++) {
      let one = areaList[i];
      let dots = one.dots.split("-").map((x) => {
        return x.split("|");
      });
      if (bg) {
        let polygon = new AMap.Polygon({
          // 底色
          map: currentMap,
          strokeWeight: 5,
          path: dots,
          fillOpacity: 0.8,
          fillColor:
            colorMap[one.area_name] ||
            colorMap1[one.area_name] ||
            colorMap2[one.area_name],
          strokeOpacity: 0,
        });
      }
      let polygon1 = new AMap.Polygon({
        // 范围线
        zIndex: 300,
        map: currentMap,
        strokeWeight: 5,
        path: dots,
        fillOpacity: 0,
        strokeColor: "#383838",
        strokeOpacity: 1,
      });

      // 画区域中心
      // let markerContent = `
      //     <div class="realPrice1">
      //       <div>${one.area_name}</div>
      //     </div>
      //     `;

      // let marker = new AMap.Marker({
      //   position: one.center.split('|'),
      //   content: markerContent,
      //   offset: new AMap.Pixel(-20, -15),
      //   zIndex: 120,
      //   draggable: true
      // });

      // marker.setMap(currentMap);
    }
  },

  drawNewDistrict: async function (currentMap, bgc) {
    let that = this;
    let areaList = await that.getAreas("区域");
    let colorMap = {
      临安区: "#004DFF",
      余杭区: "#0B8AFF",
      临平区: "#55AEFF",
      钱塘区: "#7BFFFF",
      萧山区: "#2DD2FF",
      富阳区: "#46FF8A",
      西湖区: "#FFD737",
      滨江区: "#FBAF4A",
      上城区: "#FF6B6B",
      拱墅区: "#FF3636",
    };
    let colorMap1 = {
      相城区: "#e0858a",
      姑苏区: "#faf5b5",
      高新区: "#acf4f4",
      工业园区: "#e288e5",
      吴江区: "#b7cace",
      太仓市: "#aba7b9",
      常熟市: "#c889a0",
      张家港市: "#7e7db4",
      昆山市: "#eecdaa",
      吴中区: "#9ac696",
    };
    for (let i = 0; i < areaList.length; i++) {
      let one = areaList[i];
      let dots = one.dots.split("-").map((x) => {
        return x.split("|");
      });
      if (bgc) {
        let polygon = new AMap.Polygon({
          // 底色
          map: currentMap,
          strokeWeight: 3,
          path: dots,
          fillOpacity: 0.5,
          fillColor: colorMap[one.area_name] || colorMap1[one.area_name],
          strokeOpacity: 0,
        });
      }
      let polygon1 = new AMap.Polygon({
        // 范围线
        zIndex: 300,
        map: currentMap,
        strokeWeight: 3,
        path: dots,
        fillOpacity: 0,
        strokeColor: "#383838",
        strokeOpacity: 1,
      });

      // 画区域中心
      // let markerContent = `
      //     <div class="realPrice1">
      //       <div>${one.area_name}</div>
      //     </div>
      //     `;

      // let marker = new AMap.Marker({
      //   position: one.center.split('|'),
      //   content: markerContent,
      //   offset: new AMap.Pixel(-20, -15),
      //   zIndex: 120,
      //   draggable: true
      // });

      // marker.setMap(currentMap);
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindDistrict.js